<template>
    <dropdown>

            <template v-slot:trigger>
                <div class="flex items-center space-x-4">
                    <avatar v-if="me && me.email" :src="me.profilePictureUrl" :name="me.name || me.email"/>
                    <icon-svg icon="fat-arrow-down" class="w-3 text-gray-500"/>
                </div>
            </template>

            <template v-slot:dropdown="dropdown">

                <div v-if="me && me.email" @click="dropdown.toggle()" class="rounded-md bg-white dark:bg-gray-800 shadow-xl" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                    <div class="px-4 py-3">
                        <p class="text-sm leading-5">
                        Signed in as
                        </p>
                        <p class="text-sm leading-5 font-medium text-gray-900 dark:text-gray-300  truncate">
                        {{ me.email }}
                        </p>
                    </div>
                    <div class="border-t border-gray-200"></div>
                    <div class="py-1">
                        <router-link :to="{ name: 'UserSettings', params: { ...$route.params }, query: { ...$route.query }}" class="block px-4 py-2 text-sm leading-5 text-gray-700  dark:text-gray-400 dark-hover:text-gray-900 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900" role="menuitem">Account settings</router-link>
                        <button @click="emitToggleDarkMode();" class="block px-4 py-2 text-sm leading-5 text-gray-700 dark:text-gray-400 dark-hover:text-gray-900 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900 w-full text-left" role="menuitem">Light/Dark Mode</button>

                    </div>
                    <div class="border-t border-gray-200"></div>
                    <div class="py-1">
                        
                        <router-link :to="{ name: 'Logout' }" class="block w-full text-left px-4 py-2 text-sm leading-5 text-gray-700  dark:text-gray-400 dark-hover:text-gray-900 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900" role="menuitem">
                            Sign out
                        </router-link>
                        
                    </div>
                </div>
            </template>

    </dropdown>
</template>

<script>
import { me } from '@/mixins'
export default {
    name: 'MainDropdown',
    mixins: [ me ],
    methods: {
        emitCreateProject () {
            this.$root.$emit('createProject');
        },
        emitUserSettings () {
            this.$root.$emit('userSettings');
        },
        emitToggleDarkMode () {
            this.$root.$emit('toggleDarkMode');
        },
        openMenu () {
            this.$refs['menu-button'].blur();
            this.$emit('toggle-sidebar');
        }
    },
}
</script>
